module.exports = __webpack_public_path__ + "img/single.4319d408.svg";